export enum AnalyticsSearchType {
  BILL_ID = 'BILL_ID',
  APPLICATION_NUMBER = 'APPLICATION_NUMBER',
}
